import {useEffect} from 'react';
import {IConfirmation} from '../confirmation';
interface AutoMationSmsProps {
  values: IConfirmation;
  setFieldValue: (field: string, value: string) => void;
  handleSubmit: () => void;
}
const AutoMationSms = ({
  setFieldValue,
  values,
  handleSubmit,
}: AutoMationSmsProps) => {
  useEffect(() => {
    if ('OTPCredential' in window) {
      const ac = new AbortController();
      setTimeout(() => {
        // abort after 10 minutes
        ac.abort();
      }, 10 * 60 * 1000);
      navigator.credentials
        .get({
          //@ts-ignore
          otp: {transport: ['sms']},
          signal: ac.signal,
        })
        .then(otp => {
          //@ts-ignore
          setFieldValue('confirmCode', otp.code);
          handleSubmit();
        })
        .catch(err => {
          console.log(err);
        });
    }
  }, [handleSubmit, setFieldValue]);

  return <></>;
};

export default AutoMationSms;
